<template>
  <page-header></page-header>

  <div class="innerBanner Partners-Banner position-relative">
    <div class="inBannerImg">
      <img
        src="../assets/patnerpagebanner.png"
        alt="partners"
        class="img-fluid"
      />
    </div>
    <div class="container-sm">
      <div class="col-lg-6 col-md-6">
        <div class="innerBannerText">
          <h1 class="text-uppercase mb-3">BUSINESS SOLUTIONS</h1>
          <p class="pe-4">
            For businesses of all sizes, Postmedia Parcel Services provides
            delivery throughout Canada.
          </p>
          <ul class="leading_list m-0 p-0">
            <li>Final Mile Delivery</li>
            <li>Middle Mile Logistics</li>
            <li>Induction Scanning &amp; Sortation</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="leading-edge position-relative w-100">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 col-md-6 yellow-bg p-0">
          <div class="content-middle">
            <h2 class="text-white">
              A PROVEN <span class="text-black">DISTRIBUTOR</span>
            </h2>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 p-0">
          <div class="innerBannerText">
            <ul class="leading_list m-0 p-0">
              <li>Focus on parcels and envelopes 50lbs &amp; under</li>
              <li>Proof of delivery</li>
              <li>7 days/week service</li>
              <li>Ancillary services available</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 leading-edge-order-3">
          <div class="innerBannerText our_custom-api">
            <p class="mb-3 mt-3">
              Our custom API allows you to integrate your
              <span style="display: inline-block">e-Commerce</span> platform
              directly with our system.
            </p>
            <ul class="leading_list m-0 p-0">
              <li>Built on best-in-class Commercial off-the-shelf solution</li>
              <li>Extensive Dashboard capabilities</li>
              <li>Highly Configurable</li>
              <li>Package status updates every 5 minutes</li>
              <li>Handheld technology on Android &amp; Apple OS</li>
              <li>Open API’s</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 yellow-bg leading-edge-order-4">
          <div class="content-middle">
            <h2 class="text-white">
              LEADING <span class="text-black">EDGE TECHNOLOGY</span>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="Looking-for_more position-relative w-100">
    <div class="grow-business-img">
      <img
        src="../assets/grow_business.png"
        alt="grow_business"
        class="img-fluid"
      />
    </div>
    <div class="container-sm">
      <div class="col-lg-6 col-md-6 ms-auto">
        <div class="grow-businessText">
          <h2 class="sub_heading">
            LOOKING FOR MORE WAYS <br />
            TO GROW YOUR BUSINESS?
          </h2>
          Postmedia Solutions is one of Canada’s largest premium audience
          networks offering advertising and marketing solutions for businesses
          of all sizes. We can raise the profile of your business, help outsmart
          your competition, and generate more leads for your business. With a
          portfolio of print and digital marketing solutions, the Postmedia
          network includes 130+ print and digital brands, and is visited by
          millions of Canadians each month. This provides an unparalleled
          platform of trusted, brand-safe advertising opportunities, and
          generates proprietary first-party data that enables better informed
          campaigns on the Postmedia network and other audience platforms,
          including search, social, custom content, digital audio, web
          development and more.
        </div>
      </div>
    </div>
  </div>

  <div class="getInTouchSection">
    <div class="container-sm">
      <div class="getInTouch">
        <h5>
          <p>Need more information or support?</p>
          <a href="#/support" title=""
            >GET IN TOUCH WITH US TODAY!</a
          >
        </h5>
      </div>
    </div>
  </div>
  <!-- Track Parcel page Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="p-4 fs-3">
            Proof of Delivery, review the delivery image
          </div>
        </div>
      </div>
    </div>
  </div>

  <page-footer></page-footer>
</template>

<script>
import PageFooter from "./PageFooter.vue";
import PageHeader from "./PageHeader.vue";

export default {
    beforeMount() {
    scroll(0,0)
  },
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
};
</script>